export const getApplicationRoot = (): HTMLElement =>
  document.getElementById("root") || document.body;
